import Vue from 'vue';
import clientTransformer from './../../transformers/client';

const success = ({ data }, resolve) => resolve(clientTransformer.fetch(data));

const failed = () => {};

export default id => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`/clients/${id}`)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/client/show.js